
const Api = global.Api

export default {
  login (credentials) {
    return Api().post('admin/pessoa/login', credentials)
  },
  register (credentials) {
    return Api().post('admin/pessoa/register', credentials)
  }
}
